<template>
  <div class="preview-panel">
    <div v-if="isLoading" class="preview-skeleton p-4">
      <div class="skeleton-bar mb-3" style="width: 40%; height: 24px;"></div>
      <div class="skeleton-bar mb-2" style="width: 100%; height: 14px;"></div>
      <div class="skeleton-bar mb-2" style="width: 90%; height: 14px;"></div>
      <div class="skeleton-bar mb-2" style="width: 85%; height: 14px;"></div>
      <div class="skeleton-bar mb-4" style="width: 70%; height: 14px;"></div>
      <div class="skeleton-bar mb-2" style="width: 55%; height: 20px;"></div>
      <div class="skeleton-bar mb-2" style="width: 100%; height: 14px;"></div>
      <div class="skeleton-bar mb-2" style="width: 95%; height: 14px;"></div>
      <div class="skeleton-bar mb-2" style="width: 80%; height: 14px;"></div>
      <div class="skeleton-image mt-4"></div>
    </div>
    <div v-else-if="previewHtml">
      <div class="alert alert-warning border-0 py-2 px-3 rounded-0 mb-0 small">
        <i class="fas fa-eye mr-1"></i>
        <strong>Preview</strong> — This is the report layout.
        The final PDF may differ slightly in page breaks and rendering.
      </div>
      <iframe
        class="preview-iframe"
        :srcdoc="previewHtml"
        sandbox="allow-same-origin allow-scripts"
        title="Incident Report Preview"
      ></iframe>
    </div>
    <div v-else class="text-center text-muted py-5">
      <i class="fas fa-file-alt fa-3x mb-3 d-block"></i>
      <p>No preview available. Click <strong>Preview Report</strong> to generate one.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IncidentReportPreviewPanel',
  props: {
    previewHtml: {
      type: String,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.preview-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.preview-iframe {
  width: 100%;
  height: calc(100vh - 280px);
  min-height: 400px;
  border: none;
  background: #fff;
}
.skeleton-bar {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}
.skeleton-image {
  width: 100%;
  height: 200px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 6px;
}
@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>



// WEBPACK FOOTER //
// src/views/event/incident-report/IncidentReportPreviewPanel.vue